import { AssetTypeFieldsAttachmentService as OvermapAssetTypeFieldsAttachmentService } from "@overmap-ai/core"

import type { RootState } from "../../store"
import type { AppSDK } from "../sdk"

export class AssetTypeFieldsAttachmentService extends OvermapAssetTypeFieldsAttachmentService<RootState, AppSDK> {
	host = import.meta.env.REACT_APP_API_URL
}
